import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import checkup from './checkup'
/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
export const autocomplete = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: autocomplete.url(options),
    method: 'get',
})

autocomplete.definition = {
    methods: ["get","head"],
    url: '/api/classifieds/autocomplete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
autocomplete.url = (options?: RouteQueryOptions) => {
    return autocomplete.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
autocomplete.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: autocomplete.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
autocomplete.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: autocomplete.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
const autocompleteForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: autocomplete.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
autocompleteForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: autocomplete.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::autocomplete
* @see app/Http/Controllers/ClassifiedController.php:81
* @route '/api/classifieds/autocomplete'
*/
autocompleteForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: autocomplete.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

autocomplete.form = autocompleteForm

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
export const searchListings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchListings.url(options),
    method: 'get',
})

searchListings.definition = {
    methods: ["get","head"],
    url: '/api/classifieds/search-listings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
searchListings.url = (options?: RouteQueryOptions) => {
    return searchListings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
searchListings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchListings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
searchListings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchListings.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
const searchListingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchListings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
searchListingsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchListings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::searchListings
* @see app/Http/Controllers/ClassifiedController.php:318
* @route '/api/classifieds/search-listings'
*/
searchListingsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchListings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchListings.form = searchListingsForm

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/embarcacoes/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/embarcacoes/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\ClassifiedController::store
* @see app/Http/Controllers/ClassifiedController.php:495
* @route '/embarcacoes'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/embarcacoes',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::store
* @see app/Http/Controllers/ClassifiedController.php:495
* @route '/embarcacoes'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::store
* @see app/Http/Controllers/ClassifiedController.php:495
* @route '/embarcacoes'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::store
* @see app/Http/Controllers/ClassifiedController.php:495
* @route '/embarcacoes'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::store
* @see app/Http/Controllers/ClassifiedController.php:495
* @route '/embarcacoes'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/embarcacoes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryRouteController::index
* @see app/Http/Controllers/CategoryRouteController.php:55
* @route '/embarcacoes'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
export const show = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/embarcacoes/{classified}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
show.url = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: args.classified,
    }

    return show.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
show.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
show.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
const showForm = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
showForm.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::show
* @see app/Http/Controllers/ClassifiedController.php:514
* @route '/embarcacoes/{classified}'
*/
showForm.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\ClassifiedController::contact
* @see app/Http/Controllers/ClassifiedController.php:1040
* @route '/embarcacoes/{classified}/contact'
*/
export const contact = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(args, options),
    method: 'post',
})

contact.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::contact
* @see app/Http/Controllers/ClassifiedController.php:1040
* @route '/embarcacoes/{classified}/contact'
*/
contact.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return contact.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::contact
* @see app/Http/Controllers/ClassifiedController.php:1040
* @route '/embarcacoes/{classified}/contact'
*/
contact.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::contact
* @see app/Http/Controllers/ClassifiedController.php:1040
* @route '/embarcacoes/{classified}/contact'
*/
const contactForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contact.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::contact
* @see app/Http/Controllers/ClassifiedController.php:1040
* @route '/embarcacoes/{classified}/contact'
*/
contactForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contact.url(args, options),
    method: 'post',
})

contact.form = contactForm

/**
* @see \App\Http\Controllers\ClassifiedController::verifyPhone
* @see app/Http/Controllers/ClassifiedController.php:1118
* @route '/embarcacoes/{classified}/verify-phone'
*/
export const verifyPhone = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyPhone.url(args, options),
    method: 'post',
})

verifyPhone.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/verify-phone',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::verifyPhone
* @see app/Http/Controllers/ClassifiedController.php:1118
* @route '/embarcacoes/{classified}/verify-phone'
*/
verifyPhone.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return verifyPhone.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::verifyPhone
* @see app/Http/Controllers/ClassifiedController.php:1118
* @route '/embarcacoes/{classified}/verify-phone'
*/
verifyPhone.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyPhone.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::verifyPhone
* @see app/Http/Controllers/ClassifiedController.php:1118
* @route '/embarcacoes/{classified}/verify-phone'
*/
const verifyPhoneForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verifyPhone.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::verifyPhone
* @see app/Http/Controllers/ClassifiedController.php:1118
* @route '/embarcacoes/{classified}/verify-phone'
*/
verifyPhoneForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verifyPhone.url(args, options),
    method: 'post',
})

verifyPhone.form = verifyPhoneForm

/**
* @see \App\Http\Controllers\ClassifiedController::clickPhone
* @see app/Http/Controllers/ClassifiedController.php:1188
* @route '/embarcacoes/{classified}/click-phone'
*/
export const clickPhone = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: clickPhone.url(args, options),
    method: 'post',
})

clickPhone.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/click-phone',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::clickPhone
* @see app/Http/Controllers/ClassifiedController.php:1188
* @route '/embarcacoes/{classified}/click-phone'
*/
clickPhone.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return clickPhone.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::clickPhone
* @see app/Http/Controllers/ClassifiedController.php:1188
* @route '/embarcacoes/{classified}/click-phone'
*/
clickPhone.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: clickPhone.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::clickPhone
* @see app/Http/Controllers/ClassifiedController.php:1188
* @route '/embarcacoes/{classified}/click-phone'
*/
const clickPhoneForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clickPhone.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::clickPhone
* @see app/Http/Controllers/ClassifiedController.php:1188
* @route '/embarcacoes/{classified}/click-phone'
*/
clickPhoneForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clickPhone.url(args, options),
    method: 'post',
})

clickPhone.form = clickPhoneForm

const classifieds = {
    autocomplete: Object.assign(autocomplete, autocomplete),
    searchListings: Object.assign(searchListings, searchListings),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    contact: Object.assign(contact, contact),
    verifyPhone: Object.assign(verifyPhone, verifyPhone),
    clickPhone: Object.assign(clickPhone, clickPhone),
    checkup: Object.assign(checkup, checkup),
}

export default classifieds